import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { ABOUT_TECH, ABOUT_USEFUL } from "../../lib/data";

export default function AboutIntro() {
  return (
    <section
      id="about"
      data-testid="about-intro-section"
      className="relative py-16 md:py-24 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto flex flex-col gap-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="font-display uppercase text-3xl md:text-5xl tracking-tight text-white"
        >
          Видеограф • Мобилограф • SMM
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="space-y-5 font-body text-base md:text-lg text-white/70 leading-relaxed"
        >
          <p>
            Видеограф и мобилограф с опытом 4 лет. Создаю видеоконтент,
            который помогает брендам привлекать внимание, выделяться и
            продавать.
          </p>
          <p>
            Занимаюсь созданием контента для социальных сетей и продвижением
            Instagram. Сейчас работаю с одной из ведущих строительных
            компаний Казахстана.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="flex flex-col gap-4"
        >
          {ABOUT_TECH.map((t) => (
            <div key={t.label} className="border-l-2 border-[#e63946] pl-4 py-1">
              <span className="block font-display uppercase text-sm md:text-base text-white">
                {t.label}
              </span>
              <span className="block font-body text-sm md:text-base text-white/60">
                {t.value}
              </span>
            </div>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="font-body text-base md:text-lg text-white/70 leading-relaxed"
        >
          От идеи и съёмки до монтажа и цветокоррекции — полностью
          сопровождаю процесс создания видео, чтобы каждая деталь работала на
          результат.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h3 className="font-display uppercase text-xl md:text-2xl text-white mb-4">
            Чем могу быть полезен:
          </h3>
          <ul className="space-y-2">
            {ABOUT_USEFUL.map((item) => (
              <li
                key={item}
                className="flex items-start gap-3 font-body text-sm md:text-base text-white/70"
              >
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#e63946] shrink-0" aria-hidden />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#080808] px-5 py-7 md:px-8 md:py-9"
        >
          <div className="pointer-events-none absolute right-[-8%] top-1/2 h-[125%] w-[48%] -translate-y-1/2 rounded-full bg-[#e63946]/30 blur-[90px]" />
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_82%_50%,rgba(230,57,70,0.18),transparent_42%)]" />

          <div className="relative z-10 flex items-start gap-4 md:gap-6">
            <span className="mt-0.5 font-editorial text-3xl text-[#e63946] md:text-4xl" aria-hidden>
              ✦
            </span>
            <div>
              <h3 className="font-display text-2xl uppercase leading-none text-white md:text-4xl">
                Ваш бренд достоин
              </h3>
              <h3 className="mt-1 font-display text-2xl uppercase leading-none text-[#e63946] md:text-4xl">
                лучшего контента
              </h3>
              <p className="mt-5 max-w-2xl font-body text-sm leading-relaxed text-white/70 md:text-base">
                Вместе мы превратим ваши идеи в визуал, который запомнят.
                Помогаю создавать видео, которые не просто красиво выглядят,
                а работают на результат.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex items-start gap-4 border border-white/10 rounded-xl p-5 md:p-6"
          data-testid="about-location"
        >
          <MapPin className="w-6 h-6 text-[#e63946] shrink-0 mt-0.5" aria-hidden />
          <div>
            <span className="block font-body text-[10px] tracking-[0.28em] uppercase text-white/45">
              Местоположение
            </span>
            <span className="block font-display uppercase text-lg md:text-xl text-white mt-1">
              Казахстан
            </span>
            <span className="block font-body text-xs md:text-sm text-white/50 mt-1">
              Готов к выездам и удалённой работе по проектам.
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
